import { dataProps } from './properties'

export const setSaleCategoryList = (state, payload) => {
    state.list = payload
}    

export const setSaleCategoryData = (state, payload) => {
    state.props = payload
} 

export const resetSaleCategoryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/saleCategory/mutations.js